import { Controller } from "stimulus";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return ["ownerSelect", "groupCheckbox"];
  }

  connect() {
    this.currentOwnerSelectValue = null;
    this.checkOwnerSelectGroupCheckbox();
  }

  checkOwnerSelectGroupCheckbox() {
    const thisController = this;

    const previousCheckbox = this.groupCheckboxTargets.find(checkbox =>
      checkbox.value === thisController.currentOwnerSelectValue);
    this._unSelectCheckboxTarget(previousCheckbox);

    const newCheckbox = this.groupCheckboxTargets.find(checkbox =>
      checkbox.value === thisController.ownerSelectTarget.value);
    this._selectCheckboxTarget(newCheckbox);

    this.currentOwnerSelectValue = this.ownerSelectTarget.value;
  }

  _unSelectCheckboxTarget(checkBoxTarget) {
    if (!checkBoxTarget) return;

    enableElement(checkBoxTarget);
  }

  _selectCheckboxTarget(checkBoxTarget) {
    if (!checkBoxTarget) return;

    checkBoxTarget.checked = true;
    disableElement(checkBoxTarget);
  }
}
